import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Authenticate } from "../../models/authenticate";
import { environment } from '../../../environments/environment.prod';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  login(authenticate: Authenticate) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "p1": authenticate.uniqueId,
        "p2": authenticate.pin
      })
    };

    return this.http.get(this.baseUrl + "login/creds/", httpOptions);
  }
}
